import { CapacityColumnSuffix } from '../types-v2/columns/capacity-column-suffix.type';

export const CAPACITY_COLUMN_SUffIX: Record<
  CapacityColumnSuffix,
  CapacityColumnSuffix
> = {
  HasEmptyBeds: 'HasEmptyBeds',
  EmptyBedReasons: 'EmptyBedReasons',
};
